<div id="closeBtnNew" (click)="close();">
  ×
</div>

<div id="detailBtnNew" class="fontSize16 lineHeight24" (click)="onDetailBtnClick()">答案解析</div>

<div>
  <img src="http://{{host}}/api/scenario/{{report.reports[0].totalKa}}" style="width: 100%" id="backgroundPicture">
</div>

<div id="bottomTip" class="fontSize16">
  长按图片保存并分享
</div>




<div id="head_wrap">
  <div id="closeBtn">
    <span (click)="close();">×</span>
  </div>

  <h1 id="title" class="fontSize24">情景模拟分析报告</h1>
</div>

<div id="wrap">
  <app-expert-hints [isExcellent]="false" [title]="expert_title" [content]="expert_content" [activity]="true"></app-expert-hints>

  <div id="report">
    <div id="report_introduction" class="fontSize16 lineHeight24">
      在这次情景模拟中，我们主要练习了&lt;!&ndash;{{kaNames}}&ndash;&gt;说明讨论目的、维持动力这两个关键行动。
    </div>

    <div class="key_action" *ngIf="report.reports[0].kas[0].value > 0">
      <div class="key_action_title fontSize18">
        说明讨论目的
      </div>
      <div class="key_action_introduction fontSize16 lineHeight24">
        好的开场，让辅导成功一半。寒暄客套，不宜过多；开宗明义，确保下属明白谈话目的，明确其重要性。
      </div>
      <div class="key_action_score fontSize16">
        <span class="key_action_score_title">你的得分</span>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[0].value>=1,'negativeStar':report.reports[0].kas[0].value<1}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[0].value>=2,'negativeStar':report.reports[0].kas[0].value<2}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[0].value>=3,'negativeStar':report.reports[0].kas[0].value<3}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[0].value>=4,'negativeStar':report.reports[0].kas[0].value<4}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[0].value>=5,'negativeStar':report.reports[0].kas[0].value<5}"></i>
      </div>
    </div>



    <div class="key_action" *ngIf="report.reports[0].kas[1].value > 0">
      <div class="key_action_title fontSize18">
        澄清绩效
      </div>
      <div class="key_action_introduction fontSize16 lineHeight24">
        通过提出澄清问题等方式，了解背景、原因和下属的想法。
      </div>
      <div class="key_action_score fontSize16">
        <span class="key_action_score_title">你的得分</span>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[1].value>=1,'negativeStar':report.reports[0].kas[1].value<1}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[1].value>=2,'negativeStar':report.reports[0].kas[1].value<2}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[1].value>=3,'negativeStar':report.reports[0].kas[1].value<3}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[1].value>=4,'negativeStar':report.reports[0].kas[1].value<4}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[1].value>=5,'negativeStar':report.reports[0].kas[1].value<5}"></i>
      </div>
    </div>


    <div class="key_action" *ngIf="report.reports[0].kas[2].value > 0">
      <div class="key_action_title fontSize18">
        表达期望
      </div>
      <div class="key_action_introduction fontSize16 lineHeight24">
        说明需要达到的目标、需要改善的地方，以及需要做好的准备。解释该期望对其个人、团队、组织的影响。
      </div>
      <div class="key_action_score fontSize16">
        <span class="key_action_score_title">你的得分</span>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[2].value>=1,'negativeStar':report.reports[0].kas[2].value<1}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[2].value>=2,'negativeStar':report.reports[0].kas[2].value<2}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[2].value>=3,'negativeStar':report.reports[0].kas[2].value<3}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[2].value>=4,'negativeStar':report.reports[0].kas[2].value<4}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[2].value>=5,'negativeStar':report.reports[0].kas[2].value<5}"></i>
      </div>
    </div>

    <div class="key_action" *ngIf="report.reports[0].kas[3].value > 0">
      <div class="key_action_title fontSize18">
        维持动力
      </div>
      <div class="key_action_introduction fontSize16 lineHeight24">
        防备心、抵触情绪，都会让你的辅导成果大打折扣。善用同理心、认同技巧，让下属和你愉快聊完全场，欣然作出承诺。
      </div>
      <div class="key_action_score fontSize16">
        <span class="key_action_score_title">你的得分</span>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[3].value>=1,'negativeStar':report.reports[0].kas[3].value<1}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[3].value>=2,'negativeStar':report.reports[0].kas[3].value<2}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[3].value>=3,'negativeStar':report.reports[0].kas[3].value<3}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[3].value>=4,'negativeStar':report.reports[0].kas[3].value<4}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[3].value>=5,'negativeStar':report.reports[0].kas[3].value<5}"></i>
      </div>
    </div>

    <div class="key_action" *ngIf="report.reports[0].kas[4].value > 0">
      <div class="key_action_title fontSize18">
        提供支持
      </div>
      <div class="key_action_introduction fontSize16 lineHeight24">
        提供改进建议、正面示范、发展资源，或尝试的机会。表达对下属能够胜任的信心。
      </div>
      <div class="key_action_score fontSize16">
        <span class="key_action_score_title">你的得分</span>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[4].value>=1,'negativeStar':report.reports[0].kas[4].value<1}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[4].value>=2,'negativeStar':report.reports[0].kas[4].value<2}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[4].value>=3,'negativeStar':report.reports[0].kas[4].value<3}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[4].value>=4,'negativeStar':report.reports[0].kas[4].value<4}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[4].value>=5,'negativeStar':report.reports[0].kas[4].value<5}"></i>
      </div>
    </div>

    <div class="key_action" *ngIf="report.reports[0].kas[5].value > 0">
      <div class="key_action_title fontSize18">
        达成共识
      </div>
      <div class="key_action_introduction fontSize16 lineHeight24">
        阐述具体行动方案预计会带来的效果，确保下属认同该方案，并愿意付诸实践。
      </div>
      <div class="key_action_score fontSize16">
        <span class="key_action_score_title">你的得分</span>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[5].value>=1,'negativeStar':report.reports[0].kas[5].value<1}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[5].value>=2,'negativeStar':report.reports[0].kas[5].value<2}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[5].value>=3,'negativeStar':report.reports[0].kas[5].value<3}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[5].value>=4,'negativeStar':report.reports[0].kas[5].value<4}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[5].value>=5,'negativeStar':report.reports[0].kas[5].value<5}"></i>
      </div>
    </div>

    <div class="key_action" *ngIf="report.reports[0].kas[6].value > 0">
      <div class="key_action_title fontSize18">
        设定计划
      </div>
      <div class="key_action_introduction fontSize16 lineHeight24">
        总结具体的行动步骤、完成期限、跟进方式、衡量方法。监督下属的进度，视需要进一步提供鼓励或指导。
      </div>
      <div class="key_action_score fontSize16">
        <span class="key_action_score_title">你的得分</span>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[6].value>=1,'negativeStar':report.reports[0].kas[6].value<1}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[6].value>=2,'negativeStar':report.reports[0].kas[6].value<2}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[6].value>=3,'negativeStar':report.reports[0].kas[6].value<3}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[6].value>=4,'negativeStar':report.reports[0].kas[6].value<4}"></i>
        <i class="fa fa-star" [ngClass]="{'activeStar':report.reports[0].kas[6].value>=5,'negativeStar':report.reports[0].kas[6].value<5}"></i>
      </div>
    </div>

    <button id="detailBtn" (click)="onDetailBtnClick()" class="fontSize16 lineHeight24">答案解析</button>
  </div>

  <div id="follow">
    <div class="fontSize16 lineHeight24" id="word">
      <p>
        长按关注公众号<br />
        获取<span class="fontSize18">免费</span>完整体验账号
      </p>
    </div>
    <div id="QRcode">
      <img src="/assets/picture/activity/service_qrcode.jpg">
    </div>
  </div>
</div>

<div id="smallReportAnswer">
  <h1 class="fontSize18">答案解析</h1>
  <div class="smallReportAnswerWord fontSize14 lineHeight21">
    下属工作时牢骚满腹、喋喋不休，态度消极不说，还会让整个团队士气低落，影响工作。<br />
  </div>

  <div class="smallReportAnswerWord fontSize14 lineHeight21">
    碰上这样的员工，你要如何辅导？<br />
    委婉提出？抱歉，对方顾左右而言他。<br />
    摆事实讲道理？糟糕，下属防御盾全开，对话难以为继。<br />
  </div>

  <div class="smallReportAnswerWord fontSize14 lineHeight21">
    你到底该怎么做，才能达到辅导最佳效果？
  </div>

  <div class="smallReportAnswerWord fontSize14 lineHeight21 text_class_1">
    在辅导对话中，照顾对方情绪与关注事实，就犹如天平两端，缺一不可。尤其是面对负面情绪的员工，在对话中多次展现你的同理心；指出问题的同时，也认可下属的工作表现和价值，不仅将下属的负能量消解于无形，或者还能化抱怨为动力，成为解决问题的加速器。
  </div>

  <div class="smallReportAnswerWord fontSize14 lineHeight21">
    来感受一下这个练习中，辅导Jason的最优对话选择：
  </div>

  <div class="fontSize14 lineHeight21" id="report_start">
    ——&nbsp;&nbsp;START&nbsp;&nbsp;——
  </div>

  <div class="smallReportAnswerWord fontSize14 lineHeight21 marginTop0">
    <span class="text_leader">Jason</span>：老板，你找我？<br />
    <span class="text_staff">你</span>：【<span class="text_tip">此时，应该开门见山，说明目的</span>】今天找你来，是听说你对新上线的行政系统有些看法，我们一起谈一下。<br />
    <span class="text_leader">Jason</span>：好的，可以啊。<br />
    <span class="text_staff">你</span>：听说你的对新系统抱怨很多，我想了解具体怎么回事。<br />
    <span class="text_leader">Jason</span>：新系统时不时当机，报告无法提交，无力吐槽。<br />
    <span class="text_staff">你</span>：【<span class="text_tip">表示理解他的感受，缓和负面情绪</span>】你已经挺忙的了，如果新系统时不时出些故障，也确实让人郁闷。<br />
    <span class="text_leader">Jason</span>：就是啊，负责团队在上线新系统之前，完全没有考虑过其他人的想法。<br />
    <span class="text_staff">你</span>：【<span class="text_tip">继续展现同理心</span>】作为一线的使用者，你的意见的确没有被充分考虑。那我们看看现在怎么补救好。<br />
    <span class="text_leader">Jason</span>：如果有办法，当然最好了。<br />
    【<span class="text_tip">到此，你清晰地表达了这次的讨论目的，而且在对话中，多次表达你理解对方的感受，成功扭转对方消极的心态。接下来，就可以和对方澄清原因了。</span>】<br />
    <span class="text_staff">你</span>：Jason，你使用系统碰到的这些问题，跟系统负责人提过吗？<br />
    <span class="text_leader">Jason</span>：没有……说了也没什么用吧？<br />
    <span class="text_staff">你</span>：【<span class="text_tip">一提问题，就会发现下属负能量犹在。此时，要进行鼓励，维护自尊。</span>】刚上线的系统需要一段适应期，这就像新人刚来一样。我看你对新人一向很有耐心，是不是也可以对新系统更宽容一些呢？<br />
    <span class="text_leader">Jason</span>：好吧，我知道自己的态度可能有点过……但是，以前其他的系统也是这样，时间久了也不见改善。<br />
    <span class="text_staff">你</span>：【<span class="text_tip">下属开始说心里话了，再接再厉。</span>】并不是每个人像你，擅长发现和解决问题。你有没有想过，也许他们也需要我们的反馈支持？<br />
    <span class="text_leader">Jason</span>：我同意。可是，这毕竟不是我们的工作啊。<br />
    <span class="text_staff">你</span>：但是这个系统如果不好用，受影响的还是我们自己，你觉得呢？<br />
    <span class="text_leader">Jason</span>：你说的也有道理，我去试试看。<br />
    【<span class="text_tip">至此，你的辅导已经成功了大半。最后，表达你愿意给予支持。</span>】<br />
    <span class="text_staff">你</span>：那好，辛苦你！还有什么需要我做的吗？<br />
    <span class="text_leader">Jason</span>：暂时没什么问题，谢谢老板！<br />
  </div>

  <div class="fontSize14 lineHeight21" id="report_end">
    ——&nbsp;&nbsp;END&nbsp;&nbsp;——
  </div>

</div>

<div id="closeBtnReport" (click)="onCloseBtnReportClick()"></div>
<!--
<div id="shade" (click)="onShadeClick()"></div>

<div id="share">
    <div id="shareIcon">

    </div>
    <div class="fontSize18" id="share_word">
        <p>
            分享，是一种快乐，<br/>
            邀请好友也来体验一下吧。
        </p>
    </div>
    <button id="shareBtn" (click)="onShareBtnClick()" class="fontSize14 lineHeight24">我知道了</button>
</div>
    -->



// WEBPACK FOOTER //
// ./src/app/activity-report/activity-report.component.html